import React from "react";
import { DateFilter } from "../../components/inputs/DateFilter";
import { formatDate, userNameOrEmail } from "../../util/formatters";
import { TokenCell } from "../../components/grid/cells/TokenCell";
import { get } from "lodash-es";

const EditBillingButton = ({ id }) => (
  <a className="btn btn-sm btn-outline-primary" href={`/admin/clinics/billing_rates/${id}`}>
    Edit
  </a>
);

export const CLINIC_COLUMNS = [
  {
    Header: "",
    disableFilters: true,
    disableSortBy: true,
    Cell: ({ row }) => <EditBillingButton id={get(row, "original.id")} />,
    className: "action-cell",
    minWidth: 250,
    id: "edit_button",
  },
  {
    Header: "Clinic",
    id: "clinic_name",
    accessor: "clinic_name",
    minWidth: 300,
  },
  {
    Header: "Account Number",
    id: "clinic_internal_id",
    accessor: "clinic_internal_id",
    Cell: TokenCell,
    minWidth: 300,
  },
  {
    Header: "Billing Records Count",
    id: "number_of_billing_rates",
    accessor: "number_of_billing_rates",
  },
  {
    Header: "Created",
    id: "created_at",
    accessor: (r) => formatDate(r.created_at),
    Filter: (props) => <DateFilter {...props} />,
  },
  {
    Header: "Last Updated",
    id: "updated_at",
    accessor: (r) => formatDate(r.updated_at),
    Filter: (props) => <DateFilter {...props} />,
  },
];
